import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [MatButtonModule, CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit {
  @Input() btnType: string = '';
  @Input() block = false;
  @Input() disabled: boolean | null = false;
  @Input() classNames = '';
  @Input() loading: boolean | null = false;
  @Input() customNgStyle?: {[key: string]: unknown};
  @Input() customNgClass?: {[key: string]: unknown};
  @Output() buttonEvent = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.block) {
      this.classNames += ' block-button'
    }
  }
}
